import { Form } from '@ampol/design-system';
import React from 'react';
import Env from 'Env';
import useCardModalController from '../useCardModalController';
import { EDIT_CARD_MODAL_FORM_ID } from './useEditCardModal';
import useEditCardFormController from './useEditCardFormController';

interface CardModalProps {
  children?: React.ReactNode;
  onClose?: () => void;
  id?: string;
  status?: string;
  modalType?: string;
  onEvReissueComplete?: () => void;
}

export default function EditCardModal({
  children,
  onClose,
  id = EDIT_CARD_MODAL_FORM_ID,
  status,
  modalType,
  onEvReissueComplete,
}: CardModalProps) {
  const isEvWay4Enabled = typeof Env.getIsEvWay4Enabled === 'function' ? Env.getIsEvWay4Enabled() : false;
  const editCardController = useEditCardFormController(
    onClose ?? (() => {}),
    status,
    modalType,
    isEvWay4Enabled ? onEvReissueComplete : undefined
  );
  const controller = useCardModalController(modalType, id);

  return (
    <Form
      id={id}
      schema={controller.validationSchema}
      defaultValues={controller.defaultValues}
      onChange={controller.onFormChange}
      onSubmit={editCardController.onFormSubmit}
      memoizeDefaultValues={false}
    >
      <div className='space-y-xl'>{children}</div>
    </Form>
  );
}
